// 공유 링크 탭의 목록 범위. 기본은 내 링크이고, admin 만 조직 전체를 고른다. URL `?share_scope=all`
// 이 소유하고, 기본값이면 키를 지운다. 권한이 없으면 URL 에 값이 있어도 내 링크로 처리한다.

export const shareLinkScopeSearchParamKey = "share_scope";

export type ShareLinkScope = "me" | "all";

export function readShareLinkScope(params: URLSearchParams, canViewAll: boolean): ShareLinkScope {
  return canViewAll && params.get(shareLinkScopeSearchParamKey) === "all" ? "all" : "me";
}

export function writeShareLinkScope(prev: URLSearchParams, next: ShareLinkScope): URLSearchParams {
  const params = new URLSearchParams(prev);
  if (next === "all") {
    params.set(shareLinkScopeSearchParamKey, "all");
  } else {
    params.delete(shareLinkScopeSearchParamKey);
  }
  return params;
}
